import { render, staticRenderFns } from "./table-approved.vue?vue&type=template&id=310f06bc&"
import script from "./table-approved.vue?vue&type=script&lang=js&"
export * from "./table-approved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports